import { AutomationAction, AutomationActionEnum, AutomationState } from '@/store/modules/automation/types'

const DP_ACTIONS = [AutomationActionEnum.ADD_DP, AutomationActionEnum.COPY_DP]
const DR_ACTIONS = [AutomationActionEnum.ADD_DR, AutomationActionEnum.COPY_DR]

export const mutations = {
  addAutomationGroupAction(state: AutomationState, action: AutomationAction) {
    // avoid duplicates
    if(state.editedAutomationGroup.actions.find((a) => a.action === action.action && a.value === action.value)) {
      return
    }
    // avoid exclusives (add|copy dp|dr)
    if (DP_ACTIONS.includes(action.action)) {
      state.editedAutomationGroup.actions = state.editedAutomationGroup.actions.filter((a) => !DP_ACTIONS.includes(a.action))
    } else if (DR_ACTIONS.includes(action.action)) {
      state.editedAutomationGroup.actions = state.editedAutomationGroup.actions.filter((a) => !DR_ACTIONS.includes(a.action))
    }
    state.editedAutomationGroup.actions.push(action)
  },
  removeAutomationGroupAction(state: AutomationState, action: AutomationAction) {
    state.editedAutomationGroup.actions = state.editedAutomationGroup.actions.filter((a) => a.action !== action.action || a.value !== action.value)
  }
}
